import React, { useState, useRef, useEffect, useMemo } from 'react';
import '../style.css';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import { useSelector, useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import { listGroupAPI } from '../../../store/features/listGroup';
import { suspendGroupApi } from '../../../store/features/suspendGroup';
import { deleteGroupApi } from '../../../store/features/deleteGroup';
import 'react-toastify/dist/ReactToastify.css';
import DeletePopUp from '../DeletePopUp';
import Input from '../../common/InputField';
import CustomizedHook from '../../../pages/DashboardPages/TeamManagment/AutoCompleteDropDown';
import ButtonMain from '../../common/ButtonMain';
import { addGroupAPI } from '../../../store/features/addGroup';
import { setActiveGroup, selectActiveGroup, setActiveGroupSideBar, selectActiveGroupSideBar } from '../../../Redux/group';
import { ReactComponent as Security } from '../../../assets/images/security.svg';
import { ReactComponent as GreenDot } from '../../../assets/images/greendot.svg';
import { ReactComponent as GreyDot } from '../../../assets/images/greydot.svg';
import { ReactComponent as EmptyGroupIcon } from '../../../assets/images/emptyGroupIcon.svg';
import { ReactComponent as Close } from '../../../assets/images/teamclose.svg';
import SearchInput from '../../common/SearchInputField';
import TeamManagementSkeleton from './TeamManagementSkeleton';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  TablePagination,
  Button,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  getTeamMgmtPeek,
  setTeamMgmtPeek,
  TEAM_MGMT_CACHE_TABS,
} from '../../../utils/teamManagementViewCache';

const chracterPosition = (alphabet) => {
  const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const positionOfAlphabet = alphabets.indexOf(alphabet) + 1;
  return positionOfAlphabet;
};
const colorCodesForAvatar = [
  '#405261', // A
  '#FF4D4F', // B
  '#FA541C', // C
  '#FA8C16', // D
  '#FAAD14', // E
  '#EB2F96', // F
  '#FADB14', // G
  '#A0D911', // H
  '#52C41A', // I
  '#5CDBD3', // J
  '#9254DE', // K
  '#F759AB', // L
  '#2F54EB', // M
  '#722ED1', // N
  '#1890FF', // O
  '#13C2C2', // P
  '#2DB7F5', // Q
  '#19BE6B', // R
  '#30A745', // S
  '#FA8C16', // T
  '#FAAD14', // U
  '#9254DE', // V
  '#F759AB', // W
  '#13C2C2', // X
  '#722ED1', // Y
  '#2DB7F5', // Z
];

function buildGroupRowsFromApiData(payloadData) {
  if (!Array.isArray(payloadData) || !payloadData.length) return [];
  return payloadData.map((item) => {
    const userAvatars = item.users.map((agent) => {
      const firstLetter = agent.full_name.charAt(0).toUpperCase();
      return agent?.image ? (
        <Avatar
          email={agent?.email}
          src={agent?.image}
          alt={agent?.full_name}
          key={agent.id}
        />
      ) : (
        <Avatar
          email={agent?.email}
          alt={agent?.full_name}
          sx={{
            bgcolor:
              colorCodesForAvatar[
                chracterPosition(firstLetter?.substring(0, 1).toUpperCase())
              ],
          }}
          key={agent.id}
        >
          {firstLetter}
        </Avatar>
      );
    }).filter(Boolean);

    const totalMembers = item.users.length;
    const activeMembers = item.users.filter((user) => user.is_active === true).length;

    const memberCount = userAvatars.length;
    const noUsersContent = (
      <Avatar>
        <PersonOffIcon />
      </Avatar>
    );

    return {
      id: item?.id,
      img: item?.group_image,
      name: item?.title,
      member: `${totalMembers} members`,
      activeMemberCount: activeMembers,
      totalMemberCount: totalMembers,
      activeMemberLabel: `${activeMembers}/${totalMembers} Accepting Chat`,
      user: memberCount > 0 ? userAvatars : noUsersContent,
      selected: false,

      ActiveUser: item?.is_suspended ? 'Suspended' : 'Active',
      DotColor: item?.is_suspended ? <GreyDot /> : <GreenDot />,
      menu: '...',
    };
  });
}

function TeamGroupTable(props) {
  const userData = useSelector((state) => state.loginToken);
  const businessId = userData?.response?.user?.business_id;
  const groupsPeek = getTeamMgmtPeek(businessId, TEAM_MGMT_CACHE_TABS.GROUPS);
  const initialGroupRows =
    groupsPeek?.rawData !== undefined
      ? buildGroupRowsFromApiData(groupsPeek.rawData)
      : [];

  const [searchQuery, setSearchQuery] = useState('');
  const activeGroupSideBar = useSelector(selectActiveGroupSideBar);
  const [filteredData, setFilteredData] = useState(initialGroupRows);
  const [nillRecords, setNillRecords] = useState(true);
  const [toolbarHeight, setToolbarHeight] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [activeRowId, setActiveRowId] = useState(null);
  const [activeDeleteUser, setActiveDeleteUser] = useState(null);
  const [teamGroupId, setTeamGroupId] = useState('');
  const [listOfUsers, setListOfUsers] = useState([]);
  const [name, SetName] = useState('');
  const [nameValid, SetNameValid] = useState(false);
  const [loading, SetLoading] = useState(false);
  const [data, setData] = useState(initialGroupRows);
  const [isLoading, setIsLoading] = useState(groupsPeek?.rawData === undefined);
  const toolbarRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRowForMenu] = useState(null);
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const uID = userData.response?.user?._id;
  const uRole = userData.response?.user?.role_name;

  const [stateName, setStateMethod] = useState({
    email: '',
    emailInvalid: false,
    emailInvalidMessage: '',
    emailState: false,
  });
  const navigate = useNavigate();

  const { setGroupUserList, } = props;
  const handleButtonClick = (groupId) => {
    const url = `/groupupdate/${groupId}`;
    navigate(url);
  };
  useEffect(() => {
    if (toolbarRef.current) {
      setToolbarHeight(toolbarRef.current.offsetHeight);
    }
  }, [visibleRows?.length]);

  // useEffect(() => {
  //   const handleOutsideClick = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setIsMenuOpen(false);
  //     }
  //   };

  //   if (isMenuOpen) {
  //     window.addEventListener('click', handleOutsideClick);
  //   }

  //   return () => {
  //     window.removeEventListener('click', handleOutsideClick);
  //   };
  // }, [isMenuOpen]);
  const handleChange = (event) => {
    const { name: fieldName, value } = event.target;

    switch (fieldName) {
      case 'name':
        SetName(value);

        // Mark valid only if not empty
        if (value.trim() !== '') {
          SetNameValid(true);
        } else {
          SetNameValid(false);
        }

        // Do NOT show error here
        setError('');
        break;

      default:
        setStateMethod({
          ...stateName,
          [fieldName]: value,
        });
    }
  };

  const activeGroup = useSelector(selectActiveGroup);
  const handleGroupClose = () => {
    dispatch(setActiveGroup(false));
    SetName('');
    setError('');
    SetNameValid(false);
    setListOfUsers([]);
    SetLoading(false);
    setStateMethod({
      email: '',
      emailInvalid: false,
      emailInvalidMessage: '',
      emailState: false,
    });

    getGroupsList(); // optional, depending on your refresh logic
  };

  const handleSearchInputChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    setPage(0);
    const filteredResults = data.filter((row) => row.name.toLowerCase().includes(query));
    setFilteredData(filteredResults);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const visibleRows = useMemo(() => {
    return filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [filteredData, page, rowsPerPage]);

  const getGroupsList = async () => {
    const listGroupDispatcher = dispatch(
      listGroupAPI(),
    );
    listGroupDispatcher
      .then(async (data) => {
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
          setIsLoading(false);
        } else if (data?.payload?.status === 200) {
          const list = Array.isArray(data.payload.data) ? data.payload.data : [];
          if (businessId) {
            setTeamMgmtPeek(businessId, TEAM_MGMT_CACHE_TABS.GROUPS, list);
          }
          const outputarray = buildGroupRowsFromApiData(list);
          setFilteredData(outputarray);
          setData(outputarray);
          setIsLoading(false);
        } else if (data?.payload?.status === 500) {
          setIsLoading(false);
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.status === 401) {
          setIsLoading(false);
          toast.error('Login Expired. Please login  and try again.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
          navigate('/login');
        }
      })
      .catch(async (error) => {
        setIsLoading(false);
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  };

  const handleSubmitAddGroup = async () => {
    // Trim leading space
    const trimmedName = name.trimStart();

    // Validation before proceeding
    if (trimmedName.length < 3) {
      setError('Group name must be at least 3 characters.');
      return;
    }

    if (trimmedName.length > 50) {
      setError('Group name cannot be longer than 50 characters.');
      return;
    }

    if (listOfUsers.length === 0) {
      toast.error('Please select at least one user to invite.');
      return;
    }

    // Original logic (untouched)
    SetLoading(true);
    const nameOfGroup = trimmedName;

    const addGroupDispatcher = dispatch(
      addGroupAPI({
        requestHeaders: { title: nameOfGroup, invites: listOfUsers },
      }),
    );
    addGroupDispatcher
      .then(async (data) => {
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
          SetLoading(false);
        } else if (data?.payload?.status === 200) {
          toast.success(data?.payload?.message, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
          SetName('');
          SetLoading(false);
          SetNameValid(false);
          handleGroupClose();
          getGroupsList();
        } else if (data?.payload?.status === 400) {
          toast.error('A group with a similar name already exists', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
          SetLoading(false);
        } else if (data?.payload?.status === 401) {
          toast.error('Login Expired. Please login  and try again.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
          SetLoading(false);
          navigate('/login');
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  };

  const deleteGroupHandler = async () => {
    try {
      const deletegroupdispatcher = dispatch(
        deleteGroupApi({
          id: teamGroupId,
        }),
      );
      const data = await deletegroupdispatcher;
      if (!data.payload) {
        toast.error('Some Error Occurred. Please try again later.');
        SetLoading(false);
      } else if (data.payload.status === 200) {
        toast.success(data?.payload?.message);
        props.onUnsuspend();
        getGroupsList();
      } else if (data.payload.status === 404) {
        toast.error('No Record Found');
      } else if (data.payload.status === 500) {
        toast.error('Internal Server Error. Please try again later.');
        SetLoading(false);
      } else {
        toast.error(`Unexpected response: ${JSON.stringify(data.payload)}`);
        SetLoading(false);
      }
    } catch (error) {
      toast.error('An error occurred. Please try again later.');
      SetLoading(false);
    }
  };

  const suspendGroupHandler = async (rowId) => {
    const listGroupDispatcher = dispatch(
      suspendGroupApi({
        id: rowId,
      }),
    );
    listGroupDispatcher
      .then(async (data) => {
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data.payload.status === 200) {
          toast.success('Group suspended successfully.');
          setAnchorEl(null);
          getGroupsList();
          props.onUnsuspend?.();
        } else if (data?.payload?.status === 500) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  };

  useEffect(() => {
    getGroupsList();
  }, [name]);

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );
  const tableContainerHeight = useMemo(() => {
    return `calc(100vh - ${408 + toolbarHeight}px)`;
  }, [toolbarHeight]);
  const handleRowClick = (row) => {
    dispatch(setActiveGroupSideBar(true))


    setActiveRowId(row.id);

    setGroupUserList(row);
  };

  const handleMenuClick = (event, row) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedRowForMenu(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRowForMenu(null);
  };

  const handleGroupOpen = () => {
    dispatch(setActiveGroup(true));
  };

  const capitalize = (str, lower = false) => (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase());

  if (isLoading) {
    return <TeamManagementSkeleton isGroupsTab={true} />;
  }
  const isAdmin = uRole === 'admin' || uRole === 'admin_with_billing';

  const headCells = [
    { id: "name", label: t.NAMETB },
    { id: "users", label: t.Users },
    { id: "status", label: t.STATUSTB },
    { id: "actions", label: "" },
  ];

  return !nillRecords === true ? (
    <div className="TeamChatBot-Main-Container">
      <EmptyGroupIcon />
      <p className="Chatbot-devploment">{t.NOAVAILABLEGROUPS}</p>
      <p className="Chatbot-crafting">{t.NOAVAILABLEGROUPSMSG}</p>
    </div>
  ) : (
    <>
      <div className="team-container">
        <SearchInput
          title=""
          placeholder="Search"
          className="SearchInputField-teamsection"
          value={searchQuery}
          onChange={handleSearchInputChange}
        />

        {isAdmin && (
          <ButtonMain
            className="inviteButton"
            onClick={() => handleGroupOpen()}
            title={t.ADMINGROUP01}
          />
        )}
      </div>

      <div className="Team-Section-Content-Container">
        {parseInt(filteredData?.length) < 1 ? (
          <div className="NoSuspendedAgent-main-Conatiner">
            <EmptyGroupIcon />
            <p className="NoOngoing-Chat">No Groups Available</p>
            {isAdmin && <><p className="NoOngoingChat01">
              Click on Add Group Button to add the group
            </p>
              <button
                className="NoOngoing-Chat-Button"
                type="button"
                onClick={() => handleGroupOpen()}
              >
                + Create Group
              </button></>}
          </div>
        ) : (
          <>
            <TableContainer
              sx={{
                boxShadow: "none",
                flex: 1,
                marginTop: "2px",
                marginBottom: "40px",
                height: tableContainerHeight,
                overflowY: "auto",
              }}
            >
              <Table stickyHeader sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                <TableHead>
                  <TableRow
                    sx={{
                      zIndex: 15,
                    }}

                  >
                    {headCells.map((headCell, index) => (
                      <TableCell
                        key={headCell.id}
                        sx={{
                          paddingLeft: index === 0 ? '0px' : '16px',
                          paddingBottom: '9px !important',
                          lineHeight: '1.2',
                          paddingTop: '0px',
                          zIndex: !activeGroupSideBar && !activeGroup && !activeDeleteUser ? 7 : 1,
                          backgroundColor: '#fff',
                        }}
                      >
                        <Typography sx={{
                          margin: 0, fontSize: '12px', fontWeight: 400, color: '#405261',
                          fontFamily: 'Inter',
                        }}>
                          {headCell.label}
                        </Typography>
                      </TableCell>

                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {visibleRows.map((row) => (
                    <TableRow
                      key={row.id}
                      hover
                      onClick={() => handleRowClick(row)}

                      sx={{
                        "&:hover": {
                          backgroundColor: "#F9FAFA",
                        },
                        "&:hover td": {
                          backgroundColor: "#F9FAFA",
                        },
                        "& td": {
                          height: "4rem", py: 0, verticalAlign: "middle",
                          color: "#405261",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 400,
                          height: "64px",
                        },
                      }}
                    >
                      <TableCell style={{ paddingLeft: 0 }}>
                        <div className="team-table-img">
                          {row.img ? (
                            <Avatar
                              src={row.img}
                              alt={row.name}
                              sx={{ width: 32, height: 32 }}
                            />
                          ) : (
                            <Avatar
                              sx={{
                                width: 32,
                                height: 32,
                                fontSize: '16px',
                                bgcolor: colorCodesForAvatar[
                                  chracterPosition(row.name.substring(0, 1).toUpperCase())
                                ],
                              }}
                            >
                              {row.name.substring(0, 1).toUpperCase()}
                            </Avatar>
                          )}
                          <div>
                            <p className="team-table-rowtext">
                              {capitalize(row.name)}
                            </p>
                            <p>{row.member}</p>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>
                        {row?.user && row.user.length > 0 ? (
                          <AvatarGroup
                            max={4}
                            sx={{
                              WebkitJustifyContent: 'left',
                              '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                              },
                              '& .MuiAvatar-root:nth-of-type(2)': {
                                zIndex: !activeGroupSideBar && !activeGroup && !activeDeleteUser ? 2 : 1,
                                marginLeft: '-8px',
                              },
                              '& .MuiAvatar-root:nth-of-type(3)': {
                                zIndex: 1,
                                marginLeft: '-8px',
                              },
                              '& .MuiAvatar-root:nth-of-type(4)': {
                                zIndex: 0,
                                marginLeft: '-8px',
                              },
                              '& .MuiAvatarGroup-avatar': {
                                zIndex: !activeGroupSideBar && !activeGroup && !activeDeleteUser ? 5 : 1,
                                textAlign: 'center',
                                fontFamily: 'Inter',
                                fontSize: '14px',
                                fontStyle: 'normal',
                                fontWeight: 500,
                                lineHeight: '18px',
                                transition: 'filter 0.3s ease',
                                border: 'none',
                                width: 32,
                                height: 32,
                              },
                            }}
                          >
                            {row.user}
                          </AvatarGroup>
                        ) : null}
                      </TableCell>

                      <TableCell sx={{
                        color: "#061522",

                        fontWeight: 500,
                        '& svg': {
                          display: 'inline-block',
                          // width: 14,
                          // height: 14,
                          verticalAlign: 'middle',
                          overflow: 'visible',
                          flexShrink: 0,
                        },

                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          {row.DotColor}
                          {row?.activeMemberLabel}
                        </div>
                      </TableCell>

                      <TableCell padding="none">
                        {(row.name !== 'General' && (uRole === 'admin' || uRole === 'admin_with_billing' || row.id === uID)) && (
                          <IconButton
                            onClick={(e) => handleMenuClick(e, row)}
                            size="small"
                            sx={{ ml: 1, "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" } }}
                          >
                            <MoreHorizIcon />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {!activeGroupSideBar && !activeGroup && !activeDeleteUser && <Box
              sx={{
                position: "sticky",
                bottom: 0,
                left: 0,
                width: "100%",
                background: "#fff",
                zIndex: 10,
                padding: "16px 24px",
                borderTop: "1px solid #E5E9EC",
              }}
            >
              <TablePagination
                component="div"
                count={filteredData.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[]}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelDisplayedRows={({ from, to, count }) => (
                  <Typography
                    sx={{
                      color: "#405261",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "18px",
                    }}
                  >
                    Groups {from}-{to}
                  </Typography>
                )}
                ActionsComponent={(props) => (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      marginLeft: "auto",
                    }}
                  >
                    <Button
                      onClick={(e) => props.onPageChange(e, props.page - 1)}
                      disabled={props.page === 0}
                      sx={{
                        width: "128px",
                        height: "40px",
                        flexShrink: 0,
                        borderRadius: "8px",
                        border: "1px solid #D5DCE1",
                        background: "#FFF",
                        boxShadow: "0px 1px 2px 0px rgba(6, 21, 34, 0.05)",
                        color: "#405261",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "18px",
                        textTransform: "none",
                        "&:not(.Mui-disabled):hover": {
                          backgroundColor: "#FFFFFF",
                          borderColor: "#C5CED6",
                        },
                        "&.Mui-disabled": {
                          color: "#93A1B0",
                          border: "1px solid #C5CED6",
                          bgcolor: "#F9FAFA",
                        },
                      }}
                    >
                      Previous
                    </Button>
                    <Button
                      onClick={(e) => props.onPageChange(e, props.page + 1)}
                      disabled={
                        props.page >= Math.ceil(props.count / rowsPerPage) - 1
                      }
                      sx={{
                        width: "88px",
                        height: "40px",
                        flexShrink: 0,
                        borderRadius: "8px",
                        border: "1px solid #D5DCE1",
                        boxShadow: "0px 1px 2px 0px rgba(6, 21, 34, 0.05)",
                        color: "#405261",
                        backgroundColor: "#FFFFFF",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "18px",
                        textTransform: "none",
                        "&:not(.Mui-disabled):hover": {
                          backgroundColor: "#FFFFFF",
                          borderColor: "#C5CED6",
                        },
                        "&.Mui-disabled": {
                          color: "#93A1B0",
                          border: "1px solid #C5CED6",
                          bgcolor: "#F9FAFA",
                        },
                      }}
                    >
                      Next
                    </Button>
                  </Box>
                )}
                sx={{
                  ".MuiTablePagination-toolbar": {
                    padding: 0,
                    minHeight: "unset",
                    display: "flex",
                    justifyContent: "space-between",
                  },
                  ".MuiTablePagination-spacer": {
                    display: "none",
                  },
                  ".MuiTablePagination-selectLabel": {
                    display: "none",
                  },
                  ".MuiTablePagination-select": {
                    display: "none",
                  },
                  ".MuiTablePagination-selectIcon": {
                    display: "none",
                  },
                }}
              />
            </Box>}
          </>
        )}







        {/* Actions Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{
            elevation: 0,
            sx: {
              filter: "none",
              color: '#405261',
              mt: '-5px',
              width: 200,
              paddingX: "8px",
              borderRadius: "8px", // ✅ your custom border radius
              border: "1px solid #D5DCE1", // ✅ your custom border

              boxShadow: "0 15px 20px 0 rgba(6, 21, 34, 0.05)", // ✅ soft shadow
              "& .MuiMenuItem-root": {
                px: "8px",
                py: 1,
                fontSize: '14px',
                fontFamily: 'Inter',
                color: '#405261',

                "&:hover": { color: "#061522", borderRadius: "8px", background: "#F9FAFA !important" },
              },
            },
          }}
        >
          <MenuItem onClick={() => { handleMenuClose(); handleButtonClick(selectedRow?.id); }}>
            {t.EDITGROUP}
          </MenuItem>
          <MenuItem onClick={() => { suspendGroupHandler(selectedRow?.id); }}>
            Suspend Group
          </MenuItem>
          <MenuItem sx={{
            color: '#FF4D4F !important',
            "&:hover": {
              color: '#FF4D4F !important', // ✅ stays red no matter what

              borderRadius: '8px',
            },
          }} onClick={() => { setActiveDeleteUser(selectedRow?.id); setTeamGroupId(selectedRow?.id); handleMenuClose(); }}>
            {t.DELETEALL}
          </MenuItem>
        </Menu>

        {activeDeleteUser && (
          <DeletePopUp
            onCancel={() => setActiveDeleteUser(false)}
            onDelete={() => {
              deleteGroupHandler();
              setActiveDeleteUser(false);
            }}
            teamGroupId={teamGroupId}
            setActiveDeleteUser={setActiveDeleteUser}
          />
        )}
        {activeGroup && (
          <>
            <div className="overlay" />
            <div style={{ maxHeight: '30rem', maxWidth: '26.5rem', }} className="Team-PopUp-Container">
              <div className="Team-PopUp-Header">
                <p className="PopUp-Text01">{t.ADDNEWGROUP}</p>
                <p className="PopUp-Text02" onClick={() => handleGroupClose()}>
                  <Close />
                </p>
              </div>

              <div className="PopUp-Email-Container">
                <Input

                  // className='inputGroup'

                  type="name"

                  id="name"
                  labelStyle={{ marginBottom: '5px' }}
                  name="name"
                  value={name}
                  title={t.NAMETB}

                  sx={{
                    '& input::placeholder': {
                      color: '#C5CED6',
                      opacity: 1,
                      fontSize: '14px',
                      fontWeight: 400,
                    },
                  }}
                  placeholder={t.ENTERGROUPNAME}
                  onChange={(e) => handleChange(e)}
                />
                {error && (

                  <span style={{ color: "red", fontSize: "12px", marginTop: "8px" }}>
                    {error}
                  </span>
                )}
                <br />
                <CustomizedHook setListOfUsers={setListOfUsers} />
                <br />
                <ButtonMain

                  disabled={nameValid !== true || listOfUsers.length === 0 || loading === true}
                  onClick={handleSubmitAddGroup}
                  title={loading ? t.BTN_LOADING : t.AddGroup}
                  className={
                    nameValid === true && listOfUsers.length > 0 && loading === false
                      ? 'buttonStyleEnable-team'
                      : 'buttonStyleDisable-team'
                  }
                />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default TeamGroupTable;